<template>
  <div class="exportBox">
    <el-form
        :rules="rules"
        class="exportContent"
        ref="formRef"
        :inline="true"
        :model="formData"
        label-width="120px"
        size="small"
    >
      <el-form-item label="提交预审时间" prop="time">
        <el-date-picker
            value-format="timestamp"
            v-model="formData.time"
            type="datetimerange"
            align="right"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div class="exportButtonBox">
      <el-button class="exportButton" type="primary" @click="onSubmit()">
        导出数据
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoldExport",
  data() {
    var validateDate = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择时间"));
      } else {
        callback();
      }
    };
    return {
      formData: {
        time: "",
      },
      rules: {
        time: [{validator: validateDate, trigger: "blur"}],
      }
    };
  },
  methods: {
    onSubmit() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          this.$emit("export", this.formData);
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">


.exportBox {
  display: flex;
  justify-content: space-between;
  padding: 22px 20px 4px 47px;

  .exportContent {
    display: flex;
    flex-wrap: wrap;
  }

  .exportButtonBox {
    display: flex;
    justify-content: space-between;

    .exportButton {
      height: 32px;
      line-height: 0;
      text-align: center;
      padding: 10px 20px;
    }
  }
}
</style>
